import { useEffect, useState } from 'react';

export const useMinuteTick = (): number => {
  const [currentMinute, setCurrentMinute] = useState<number>(Date.now());

  useEffect(() => {
    const intervalId: NodeJS.Timeout = setInterval((): void => {
      setCurrentMinute(Date.now());
    }, 60000);
    return (): void => clearInterval(intervalId);
  }, []);

  return currentMinute;
};
